import type { Theme } from '@mildang/mui';
import { css as emotionCss } from '@emotion/react';
import { cva } from '@mildang/styled-system/css';

export const hideScrollStyle = emotionCss`
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const scrollbarStyle = (theme: Theme) => emotionCss`
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.palette.text.tertiary};
    border-radius: 20px;
  }
`;

export const commonScrollbarStyle = ({
  theme,
  horizontalScroll = false,
}: {
  theme: Theme;
  horizontalScroll?: boolean;
}) => emotionCss`
  &::-webkit-scrollbar {
    width: 8px;
    ${horizontalScroll &&
  emotionCss`
      height: 8px;
    `
  }
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.palette.primary.stroke};
    border-radius: 20px;
    background-clip: padding-box;
    border: 2px solid transparent;
  }
`;

export const commonScrollbarPandaStyle = cva({
  base: {
    '&::-webkit-scrollbar': {
      width: 8,
      height: 'auto',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 20,
      backgroundClip: 'padding-box',
      border: '2px solid transparent',
      backgroundColor: 'mui.primary.stroke',
    },
  },
  variants: {
    horizontal: {
      true: {
        height: 8,
      },
    },
  },
});

export interface DraggableStyleProps {
  theme: Theme;
  isDragging?: boolean;
  isSelected?: boolean;
}
export const draggableStyle = ({
  theme,
  isDragging = false,
  isSelected = false,
}: DraggableStyleProps) => emotionCss`
  background-color: ${theme.palette.background.default};
  cursor: pointer;
  transition: ${theme.transitions.create('background-color', {
  duration: theme.transitions.duration.shortest,
  easing: theme.transitions.easing.sharp,
})};

  --handler-opacity: 0;
  ${isDragging &&
  emotionCss`
    box-shadow: ${theme.shadows[3]};
    --handler-opacity: 1;
  `
  }
  &:hover {
    background-color: ${theme.palette.background.secondary};
    --handler-opacity: 1;
    ${isSelected &&
  emotionCss`
      background-color: ${theme.palette.secondary.lightHover};
    `
  }
  }
  ${isSelected &&
  emotionCss`
    background-color: ${theme.palette.secondary.lightActive};
  `
  }
`;

export const timeInputStyle = emotionCss`
  & input[type='time']::-webkit-calendar-picker-indicator {
    width: 22px;
    height: 22px;
  }
`;

export const smallViewportHeightStyle = emotionCss`
  height: calc(100svh - var(--safe-area-inset-bottom));
  height: calc(100svh - var(--safe-area-inset-bottom));
`;
